import React, { useEffect, useState } from "react";
// import FeatherIcon from "feather-icons-react";
import { Link } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable";
import PropTypes from "prop-types";
import { Spin, Tooltip } from "antd";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import axios from "axios";
import { BASE_CRM_URL } from "../../../../components/config/config";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import EditExpenses from "../../Expenses/EditExpenses";

const ProjectExpenses = ({ projectId }) => {
  const columns = [
    {
      title: "Category",
      dataIndex: "expense_category_name",
      render: (_, record) => {
        const expense_category_name = record.expense_category_name || "N/A";

        const truncatedNote =
          expense_category_name.length > 40
            ? `${expense_category_name.substring(0, 40)}...`
            : expense_category_name;

        return (
          <div className="d-flex align-items-start">
            <div className="ms-3">
              <div className="fw-semibold" title={expense_category_name}>
                {truncatedNote}
              </div>

              <small className="text-muted">
                <i className="fa-solid fa-user me-2"></i>
                {record.addedfrom_name || "N/A"}
              </small>
            </div>
          </div>
        );
      },
    },
    {
      title: "Reason",
      dataIndex: "expense_name",

      render: (_, record) => (
        <>
          <div className="fw-semibold">{record.expense_name}</div>
        </>
      ),
    },

    {
      title: "Amount",
      dataIndex: "amount",

      render: (amount) => (
        <span className="fw-bold text-success">
          <i className="fa-solid fa-indian-rupee-sign me-2"></i>
          {amount}
        </span>
      ),
    },

    {
      title: "Payment",

      render: (_, record) => (
        <>
          <div>
            <i className="fa-regular fa-calendar me-2 text-primary"></i>

            {dayjs(record.date).format("DD-MM-YYYY") || "-"}
          </div>

          <small className="text-muted">
            <i className="fa-solid fa-credit-card me-2"></i>
            {record.payment_mode_name || "N/A"}
          </small>
        </>
      ),
    },
    {
      title: "Expense Note",
      dataIndex: "note",
      render: (note) => {
        if (!note) return "-";

        const shortText =
          note.length > 30 ? `${note.substring(0, 30)}...` : note;

        return (
          <Tooltip title={note}>
            <span style={{ cursor: "pointer" }}>{shortText}</span>
          </Tooltip>
        );
      },
    },

    {
      title: "Customer",
      dataIndex: "client_name",
      render: (text) => {
        if (!text) return "-";

        const shortText =
          text.length > 30 ? `${text.substring(0, 30)}...` : text;

        return (
          <Tooltip title={text}>
            <span style={{ cursor: "pointer" }}>{shortText}</span>
          </Tooltip>
        );
      },
    },

    {
      title: "Action",
      width: 70,
      render: (_, record) => (
        <>
          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                title="Edit"
                onClick={(e) => {
                  e.preventDefault();
                  handleEditExpense(record);
                }}
                className="text-primary me-2 p-2"
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const [editExpenseOpen, setEditExpenseOpen] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const handleEditExpense = (record) => {
    setSelectedExpense(record);
    setEditExpenseOpen(true);
  };

  const handleCloseEditExpense = () => {
    setEditExpenseOpen(false);
    setSelectedExpense(null);
  };

  const [expensesData, setExpensesData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getExpenses = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_CRM_URL}expenses/GetExpensesByProjId?ProjId=${projectId}`,
      );

      if (response.data.Status) {
        setExpensesData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No expenses found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("expenses API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getExpenses();
  }, []);

  return (
    <div className="page-wrapper py-0">
      <div className="content py-0">
        <div className="d-flex justify-content-between mb-2">
          {/* Left section with heading and description */}
          <div className="d-flex flex-column">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <h4 className="breadcrumb-item " aria-current="page">
                  Project Expenses
                </h4>
              </ol>
            </nav>
          </div>
        </div>

        <div className="card table-list-card" style={{ marginTop: "-1rem" }}>
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set p-3"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={expensesData} />
              )}
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      <EditExpenses
        open={editExpenseOpen}
        onClose={handleCloseEditExpense}
        getExpenses={getExpenses}
        record={selectedExpense}
      />
    </div>
  );
};

ProjectExpenses.propTypes = {
  projectId: PropTypes.number,
};

export default ProjectExpenses;
